import { useState } from "react";
import Responsive from "../../../Components/Responsive";
import { Input } from "rsuite";
import Attachments from "../../Packages/Attachments/Attachments.component";
import styles from "./styles/programStyles";
import Translation from "../../../translation/translation";

const ProgramItem = ({ p, index, model, setModel }) => {
  const [state, setState] = useState([]);
  return (
    <div key={index} style={styles.programContainer}>
      <div style={styles.dayLabel}>
        {Translation.day} {p.day}
      </div>
      <div style={styles.programContent}>
        <Responsive l={5} xl={4} className="p-10">
          <label>{Translation.name} : </label>
          <Input block value={p.name} disabled />
        </Responsive>
        <Responsive l={5} xl={5} className="p-10">
          <label>{Translation.description} : </label>
          <Input as="textarea" rows={3} block value={p.description} disabled />
        </Responsive>
      </div>
      <Attachments
        model={model}
        setModel={setModel}
        isProgram
        index={index}
        showFileInput={false}
        program={p}
        state={state}
        setState={setState}
      />
    </div>
  );
};

export default ProgramItem;
